import script from "./ExpiryDatesScanView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExpiryDatesScanView.vue?vue&type=script&setup=true&lang=ts"

import "./ExpiryDatesScanView.vue?vue&type=style&index=0&id=66f664b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66f664b7"]])

export default __exports__